import { render, staticRenderFns } from "./Dependente.vue?vue&type=template&id=158cc204&"
import script from "./Dependente.vue?vue&type=script&lang=js&"
export * from "./Dependente.vue?vue&type=script&lang=js&"
import style0 from "./Dependente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports